import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
type CheckboxChipProps = {
  isSelected: boolean;
  onChange: () => void;
  label: string;
  value: string;
};
const CheckboxChip = t0 => {
  const $ = _c(12);
  const {
    isSelected,
    onChange,
    label,
    value
  } = t0;
  const t1 = !isSelected;
  let t2;
  if ($[0] !== isSelected || $[1] !== t1) {
    t2 = cx("flex flex-row items-center rounded cursor-pointer px-2 py-1 bg-background-primary", {
      "border border-dashed border-tertiary hover:bg-hover-control": t1,
      "border border-solid border-primary": isSelected
    });
    $[0] = isSelected;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const containerClass = t2;
  let t3;
  if ($[3] !== isSelected || $[4] !== label || $[5] !== onChange || $[6] !== value) {
    t3 = <Checkbox value={value} label={label} checked={isSelected} onChange={onChange} />;
    $[3] = isSelected;
    $[4] = label;
    $[5] = onChange;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== containerClass || $[9] !== isSelected || $[10] !== t3) {
    t4 = <div className={containerClass} data-is-selected={isSelected}>{t3}</div>;
    $[8] = containerClass;
    $[9] = isSelected;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default CheckboxChip;